{ "id": "cape-aventurier", "name": "Cape de l'Aventurier", "slot": "cape", "set": "aventurier", "tier": 1, "price": 45, "icon": "icons/items/cape-aventurier", "stats": { "force": 5, "intelligence": 5, "chance": 5, "agilite": 5 } }
